import { combineReducers } from "redux";

import ajaxCounter from "./ajaxCounterReducer";

import settings from "./settingReducer";
import layout from "./layoutReducer";
import exception from "./exceptionReducer";
import validatieStatussen from "./validatieStatusReducer";

import referentie from "./referentieReducer";

const rootReducer = combineReducers({
	ajaxCounter,
	settings,
	layout,
	validatieStatussen,
	referentie,
	exception
});

export default rootReducer;